import router from "../router/index.js";
import axios from "axios";
const looksMojibake = (value) => {
  if (typeof value !== 'string') {
    return false
  }
  return /Ð|Ñ|Ã|Â|â€™|â€“|â€”|â€œ|â€|â€¢|�/.test(value)
}

const isSuccessfulResponse = (response) => {
  const status = Number(response && response.status)
  return status >= 200 && status < 300
}

const isUnauthorizedResponse = (response) => {
  const status = Number(response && response.status)
  return status === 401 || status === 419
}

const buildUserFromResponse = (data) => {
  if (!data || typeof data !== 'object') {
    return null
  }
  const userId = Number(data.user_id)
  if (!Number.isFinite(userId) || userId <= 0) {
    return null
  }
  return {
    user_id: userId,
    user_name: data.user_name,
    firstname: '',
    role: data.role,
    text_specialities: data.text_specialities ?? data.user_specialities,
    user_avatar: data.user_avatar,
    speciality_verified_at: data.speciality_verified_at,
    user_specialities: data.user_specialities,
  }
}

const buildUserFromProfileInfo = (data) => {
  if (!data || typeof data !== 'object') {
    return null
  }
  const userId = Number(data.user_id)
  if (!Number.isFinite(userId) || userId <= 0) {
    return null
  }
  return {
    user_id: userId,
    user_name: data.user_name,
    firstname: '',
    role: data.role,
    text_specialities: data.text_specialities ?? data.user_specialities,
    user_avatar: data.user_avatar,
    speciality_verified_at: data.speciality_verified_at,
    user_specialities: data.user_specialities,
  }
}

const parseJwtPayload = (token) => {
  if (!token || typeof token !== 'string') {
    return null
  }
  const parts = token.split('.')
  if (parts.length < 2) {
    return null
  }
  const payload = parts[1]
  const normalized = payload.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(payload.length / 4) * 4, '=')
  try {
    return JSON.parse(atob(normalized))
  } catch (e) {
    return null
  }
}

const getTokenExpiryFromJwt = (token) => {
  const payload = parseJwtPayload(token)
  const exp = Number(payload && payload.exp ? payload.exp : 0)
  if (!Number.isFinite(exp) || exp <= 0) {
    return 0
  }
  return exp * 1000
}

const resolveTokenExpiryTimestamp = () => {
  const token = localStorage.getItem('x_xsrf_token')
  if (!token) {
    return 0
  }
  const jwtExpiry = getTokenExpiryFromJwt(token)
  if (jwtExpiry > 0) {
    return jwtExpiry
  }
  const raw = localStorage.getItem('x_xsrf_token_time')
  if (raw) {
    const localExpiry = new Date(raw).getTime()
    if (Number.isFinite(localExpiry) && localExpiry > 0) {
      return localExpiry
    }
  }
  return 0
}

const hasNonExpiredToken = () => {
  const token = localStorage.getItem('x_xsrf_token')
  if (!token) {
    return false
  }
  const expiry = resolveTokenExpiryTimestamp()
  if (expiry <= 0) {
    return true
  }
  return expiry > Date.now()
}

const clearStoredSession = () => {
  localStorage.removeItem('x_xsrf_token')
  localStorage.removeItem('x_xsrf_token_time')
  localStorage.removeItem('user_info')
}

const isCurrentToken = (token) => {
  if(!token){
    return false
  }
  return token === localStorage.getItem('x_xsrf_token')
}

const MAX_BOOTSTRAP_UNAUTHORIZED_ATTEMPTS = 3
const bootstrapUnauthorizedByToken = new Map()
const incrementBootstrapUnauthorized = (token) => {
  if(!token){
    return 0
  }
  const nextValue = (bootstrapUnauthorizedByToken.get(token) || 0) + 1
  bootstrapUnauthorizedByToken.set(token, nextValue)
  return nextValue
}
const resetBootstrapUnauthorized = (token) => {
  if(!token){
    return
  }
  bootstrapUnauthorizedByToken.delete(token)
}
const shouldForceLogoutByUnauthorized = (token) => {
  if(!token){
    return false
  }
  const count = Number(bootstrapUnauthorizedByToken.get(token) || 0)
  return count >= MAX_BOOTSTRAP_UNAUTHORIZED_ATTEMPTS
}

const applyUserToState = (state, user) => {
  if (!user || typeof user !== 'object' || !user.user_id) {
    return
  }
  localStorage.setItem('user_info', JSON.stringify(user))
  state.user = user
  state.isAuth = true
}

const requestUser = async (url, token) => {
  if(!token){
    return null
  }
  const requestUrl = `${url}${url.includes('?') ? '&' : '?'}_ts=${Date.now()}`
  try {
    return await axios.get(requestUrl, {
      skipLoader: true,
      authBootstrapRequest: true,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache, no-store, max-age=0',
        Pragma: 'no-cache'
      }
    })
  } catch (err) {
    return err && err.response ? err.response : null
  }
}
const loadFreshUser = async (token) => {
  if(!token){
    return { user: null, unauthorized: false, token: '' }
  }
  const userResponse = await requestUser('/api/user', token)
  if (isUnauthorizedResponse(userResponse)) {
    return { user: null, unauthorized: true, token }
  }
  if (isSuccessfulResponse(userResponse)) {
    const user = buildUserFromResponse(userResponse.data)
    if (user) {
      return { user, unauthorized: false, token }
    }
  }

  const profileResponse = await requestUser('/api/profile/info?lite=1', token)
  if (isUnauthorizedResponse(profileResponse)) {
    return { user: null, unauthorized: true, token }
  }
  if (isSuccessfulResponse(profileResponse)) {
    const user = buildUserFromProfileInfo(profileResponse.data)
    if (user) {
      return { user, unauthorized: false, token }
    }
  }

  return { user: null, unauthorized: false, token }
}

let loadFreshUserPromise = null
let loadFreshUserPromiseToken = ''
const getFreshUser = (token) => {
  if(!token){
    return Promise.resolve({ user: null, unauthorized: false, token: '' })
  }
  if (!loadFreshUserPromise || loadFreshUserPromiseToken !== token) {
    loadFreshUserPromiseToken = token
    loadFreshUserPromise = loadFreshUser(token).finally(() => {
      if(loadFreshUserPromiseToken === token){
        loadFreshUserPromise = null
        loadFreshUserPromiseToken = ''
      }
    })
  }
  return loadFreshUserPromise
}

const getStoredUser = () => {
  const raw = localStorage.getItem('user_info')
  if(!raw){
    return null
  }
  try{
    const parsed = JSON.parse(raw)
    if (parsed && looksMojibake(parsed.user_name)) {
      localStorage.removeItem('user_info')
      return null
    }
    return parsed
  }catch (e){
    localStorage.removeItem('user_info')
    return null
  }
}
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export const authModule = {
  state: () => ({
    isAuth: false, //Временно
    user: getStoredUser() || {}
  }),

  getters: {
    getUser(state) {
      return state.user
    }
  },

  mutations: {
    setStateAuth(state) {
      state.isAuth = true
    },
    setAuthUser(state, user) {
      applyUserToState(state, user)
    },

    setUserInfo(state) {
      if(!hasNonExpiredToken()){
        state.user = {}
        state.isAuth = false
        clearStoredSession()
        return
      }
      const token = localStorage.getItem('x_xsrf_token') || ''
      getFreshUser(token).then(result => {
        if(result && result.unauthorized && isCurrentToken(token)){
          if(shouldForceLogoutByUnauthorized(token)){
            state.user = {}
            state.isAuth = false
            clearStoredSession()
          }
          return
        }
        if(!isCurrentToken(token)){
          return
        }
        const user = result && result.user ? result.user : null
        if(!user){
          return
        }
        applyUserToState(state, user)
      }).catch(() => {
      })
    },

    setUser(state) {
      if (!hasNonExpiredToken()) {
        state.user = {}
        state.isAuth = false
        clearStoredSession()
        return
      }
      const token = localStorage.getItem('x_xsrf_token') || ''
      let stateUserInfo = getStoredUser()

      if (stateUserInfo && typeof stateUserInfo === 'object' && stateUserInfo.user_id) {
        state.user = stateUserInfo
        state.isAuth = true
        getFreshUser(token).then(result => {
          if(result && result.unauthorized && isCurrentToken(token)){
            if(shouldForceLogoutByUnauthorized(token)){
              state.user = {}
              state.isAuth = false
              clearStoredSession()
            }
            return
          }
          if(!isCurrentToken(token)){
            return
          }
          const user = result && result.user ? result.user : null
          if(!user){
            return
          }
          applyUserToState(state, user)
        }).catch(() => {
        })
      } else {
        state.user = {}
        state.isAuth = false
        getFreshUser(token).then(result => {
          if(result && result.unauthorized && isCurrentToken(token)){
            if(shouldForceLogoutByUnauthorized(token)){
              clearStoredSession()
            }
            return
          }
          if(!isCurrentToken(token)){
            return
          }
          const user = result && result.user ? result.user : null
          if(!user){
            return
          }
          applyUserToState(state, user)
        }).catch(() => {
        })
      }
    },
    clearUser(state) {
      state.user = {}
      state.isAuth = false
    },

    logout(state) {
      axios.post('/logout')
        .then(res => {
          state.user = {}
          state.isAuth = false
          if (localStorage.getItem('x_xsrf_token')) {
            localStorage.removeItem('x_xsrf_token')
          }
          if (localStorage.getItem('x_xsrf_token_time')) {
            localStorage.removeItem('x_xsrf_token_time')
          }

          if (localStorage.getItem('user_info')) {
            localStorage.removeItem('user_info')
          }
          router.push({
            name: 'home'
          })
        })

    }
  },

  actions: {
    async bootstrapUser({ state, commit }) {
      if (!hasNonExpiredToken()) {
        commit('clearUser')
        clearStoredSession()
        return false
      }
      const token = localStorage.getItem('x_xsrf_token') || ''
      if(!token){
        commit('clearUser')
        return false
      }
      if(!isCurrentToken(token)){
        return false
      }

      const stateUserInfo = getStoredUser()
      if (stateUserInfo && typeof stateUserInfo === 'object' && stateUserInfo.user_id) {
        commit('setAuthUser', stateUserInfo)
      } else {
        commit('clearUser')
      }

      const result = await getFreshUser(token)
      if (result && result.unauthorized) {
        const unauthorizedCount = incrementBootstrapUnauthorized(token)
        const hasResolvedUser = !!(state.user && state.user.user_id)
        if (!hasResolvedUser && unauthorizedCount >= MAX_BOOTSTRAP_UNAUTHORIZED_ATTEMPTS) {
          commit('clearUser')
        }
        if (isCurrentToken(token) && unauthorizedCount >= MAX_BOOTSTRAP_UNAUTHORIZED_ATTEMPTS) {
          clearStoredSession()
          resetBootstrapUnauthorized(token)
        }
        return false
      }
      if(!isCurrentToken(token)){
        return false
      }
      resetBootstrapUnauthorized(token)

      const user = result && result.user ? result.user : null
      if (user) {
        commit('setAuthUser', user)
        return true
      }

      return !!(state.user && state.user.user_id)
    },
    async bootstrapUserWithRetry({ dispatch }, payload = {}) {
      const attemptsRaw = Number(payload && payload.attempts ? payload.attempts : 3)
      const delayRaw = Number(payload && payload.delayMs ? payload.delayMs : 250)
      const attempts = Number.isFinite(attemptsRaw) && attemptsRaw > 0 ? Math.min(attemptsRaw, 8) : 3
      const delayMs = Number.isFinite(delayRaw) && delayRaw >= 0 ? delayRaw : 250

      for (let i = 0; i < attempts; i += 1) {
        const bootstrapped = await dispatch('bootstrapUser')
        if (bootstrapped) {
          return true
        }
        if (!localStorage.getItem('x_xsrf_token')) {
          return false
        }
        if (i < attempts - 1) {
          await wait(delayMs * (i + 1))
        }
      }

      return false
    }
  },

  namespaced: true
}
